<div *ngIf="ready" class="flow-item">
  <app-content-repeater [items]="contents"></app-content-repeater>
</div>
